import { oc } from '@orpc/contract';
import { importPreviewOutputSchema, importUploadInputSchema } from '../schemas/import.schemas.js';
export const previewImportContract = oc
    .route({
    method: 'POST',
    path: '/import/preview',
    tags: ['Import'],
    summary: 'Dry-run a filled-in template: validate, resolve codes and judge every row',
    description: 'Writes nothing. Each row is type-checked against the same field schemas the wizard uses, its vehicle/scenario/route codes are resolved, the scenario/route coherence is re-checked, an existing run under the same natural key rejects it as a duplicate, and the result calculation plus the validity engine run in memory to show the status the row would carry.',
})
    .input(importUploadInputSchema)
    .output(importPreviewOutputSchema);
//# sourceMappingURL=preview-import.contract.js.map